import React, {
  useContext,
  useEffect,
} from 'react';
import {Context} from '../contexts/WordList';
import {availableTagEntries} from '../helpers/availableTagEntries';
import {getTagIcon} from '../helpers/tagIcons';

const _ = require('lodash');

export const FilterList = (props) => {
  const [state, dispatch] = useContext(Context);

  const {displayFilterList, onClose} = props;

  // Close on Escape while the filter modal is open.
  useEffect(() => {
    if (!displayFilterList) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [displayFilterList, onClose]);

  if (!displayFilterList) {
    return null;
  }

  const handleClose = () => {
    onClose();
  };

  const handleTagFilterChange = (event) => {
    let newTagsFilter = state.tagsFilter.slice();

    const currTag = event.target.name;

    if (event.target.checked) {
      newTagsFilter = _.concat(newTagsFilter, currTag);
    } else {
      _.pull(newTagsFilter, currTag);
    }

    dispatch({
      type: 'TAGS_FILTER',
      payload: newTagsFilter,
    });
  };

  const handleHideTranslation = () => {
    dispatch({
      type: 'HIDE_TRANSLATION',
      payload: !state.hideTranslation,
    });
  };

  // Count filters that actually hide words (unchecked tags), matching
  // the badge shown on the topbar filter button.
  const hiddenCount = availableTagEntries
      .filter((tag) => tag !== 'Add' && !state.tagsFilter.includes(tag))
      .length;

  return (
    <div className="overlay" onClick={handleClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4}}>
          <h2 className="modal-title">Filters</h2>
          {hiddenCount > 0 && (
            <span className="filter-modal-badge">
              {hiddenCount} hidden
            </span>
          )}
        </div>
        <p className="modal-subtitle">Choose which categories to display</p>

        <div className="form-col">
          {/* Hide translation toggle */}
          <label
            className={`filter-hide-translation${state.hideTranslation ? ' checked' : ''}`}
          >
            <span className="filter-hide-translation-label">Hide translation</span>
            <input
              type="checkbox"
              onChange={handleHideTranslation}
              checked={state.hideTranslation}
              name="Hide translation"
            />
          </label>

          {/* Category filters grid */}
          <div className="filter-grid">
            {availableTagEntries
              .filter((category) => category !== 'Add')
              .map((category) => {
                const isChecked = state.tagsFilter.includes(category);
                return (
                  <label
                    key={category}
                    className={`filter-item${isChecked ? ' checked' : ''}`}
                  >
                    <input
                      type="checkbox"
                      onChange={handleTagFilterChange}
                      checked={isChecked}
                      name={category}
                    />
                    <span className="filter-item-label">
                      {getTagIcon(category)} {category}
                    </span>
                  </label>
                );
              })}
          </div>

          <button type="button" className="btn btn-primary" style={{width: '100%', justifyContent: 'center'}} onClick={handleClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};